exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-content h2{font-family:protipo,sans-serif !important;font-weight:400 !important;font-size:25px !important;color:#385369 !important}\n", ""]);

